<script setup>
import { computed, ref } from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import AdminTabsLayout from '@/Layouts/AdminTabsLayout.vue'
import UserEditHeader from '@/components/admin/user-edit/UserEditHeader.vue'
import ProfileSection from '@/components/admin/user-edit/ProfileSection.vue'
import RoleSection from '@/components/admin/user-edit/RoleSection.vue'
import CompanySection from '@/components/admin/user-edit/CompanySection.vue'
import CountySection from '@/components/admin/user-edit/CountySection.vue'
import AccountActionsSection from '@/components/admin/user-edit/AccountActionsSection.vue'
import DangerZoneSection from '@/components/admin/user-edit/DangerZoneSection.vue'
import { useFeature } from '@/composables/useFeature'

defineOptions({ layout: [AppLayout, AdminTabsLayout] })

defineProps({
  user: { type: Object, required: true },
  guards: { type: Object, default: () => ({ is_self: false, is_last_admin: false }) },
  companies: { type: Array, default: () => [] },
  roles: { type: Array, default: () => [] },
  permissions: { type: Array, default: () => [] },
  countyAccess: { type: Array, default: () => [] },
  // RED-328: { override, company_default, effective }
  analytics: { type: Object, default: () => ({ override: null, company_default: false, effective: false }) },
})

const qvDirectEnabled = useFeature('qv-direct-prediction')

// Tab config — adding the future Activity tab is one entry here.
// The Maakonnad tab ships behind the qv-direct-prediction release flag.
const tabs = computed(() => [
  { value: 'profile', label: 'messages.admin.user.tabs.profile', component: ProfileSection },
  { value: 'role', label: 'messages.admin.user.tabs.role', component: RoleSection },
  { value: 'company', label: 'messages.admin.user.tabs.company', component: CompanySection },
  ...(qvDirectEnabled.value
    ? [{ value: 'counties', label: 'messages.admin.user.tabs.counties', component: CountySection }]
    : []),
  { value: 'account', label: 'messages.admin.user.tabs.account', component: AccountActionsSection },
  { value: 'danger', label: 'messages.admin.user.tabs.danger', component: DangerZoneSection },
])

const activeTab = ref('profile')
</script>

<template>
  <UserEditHeader :user="user" />

  <Tabs v-model:value="activeTab" lazy class="mt-4">
    <TabList>
      <Tab v-for="tab in tabs" :key="tab.value" :value="tab.value">
        {{ $t(tab.label) }}
      </Tab>
    </TabList>
    <TabPanels>
      <TabPanel v-for="tab in tabs" :key="tab.value" :value="tab.value">
        <component
          :is="tab.component"
          :user="user"
          :guards="guards"
          :companies="companies"
          :roles="roles"
          :permissions="permissions"
          :county-access="countyAccess"
          :analytics="analytics"
        />
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>
